import {
  Button,
  CloseButton,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  Box,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Flex,
  Alert,
  AlertIcon,
  HStack,
  Badge,
  Text,
  VStack,
  Spinner,
  IconButton,
} from "@chakra-ui/react";
import { useQuery } from "@tanstack/react-query";
import { searchAccommodations } from "../../services/accommodations";
import { useSearchParams } from "react-router-dom";
import RoomCard from "../../components/room-card/RoomCard";
import { useEffect, useState, forwardRef, useRef } from "react";
import { AccommodationCardSkeleton } from "../../components/accommodation-card/AccommodationCard";
import { CloseIcon } from '@chakra-ui/icons';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import { faTrashCan, faHotel } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
const RoomPicker = forwardRef(
  ({ rooms, type, onRoomSelect, previewOnly, isHotel }, ref) => {
    return (
      <Box ref={ref} gap={3}>
        {rooms.map((room, index) => (
          <Box w="100%" key={index}>
            <RoomCard
              isForTour={true}
              isHotel={isHotel}
              previewOnly={previewOnly}
              room={room}
              type={type}
              onSelect={(quantity) => {
                onRoomSelect(room.id, quantity);
              }}
            />
          </Box>
        ))}
      </Box>
    );
  }
);


const UpsellBox = () => {
  const { t } = useTranslation("home");
  const [isOpenBox, setIsOpenBox] = useState(true);

  const closeBox = () => setIsOpenBox(false);

  return (
      <>
        {isOpenBox && (
            <Box
                position="relative"
                top="20px"
                //right="20px"
                width="80%"
                padding="5px"
                bg="teal.500"
                color="white"
                borderRadius="8px"
                boxShadow="lg"
            >
              {/* Close Button */}
              <IconButton
                  aria-label="Close"
                  icon={<CloseIcon />}
                  position="absolute"
                  top="5px"
                  right="5px"
                  onClick={closeBox}
                  size="sm"
                  variant="ghost"
                  color="white"
              />

              {/* Content */}
              <Text fontWeight="bold" fontSize="lg">{t("tours.stayMenu.needStay")}</Text>
              <Text mt={2}>{t("tours.stayMenu.upsellText")}</Text>

            </Box>
        )}
      </>
  );
};

const ChooseStayMenu = ({ tourStayParam, onStaySelect }) => {
  const { t } = useTranslation("home");
  const [tourStay] = useState(tourStayParam);
  const [searchParams] = useSearchParams();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [roomQuantities, setRoomQuantities] = useState([]);
  const [accommodationsData, setAccommodationsData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [hasNextPage, setHasNextPage] = useState(false);
  const roomPickerRef = useRef(null);

  const removeItem = (id) => {
    const updatedStay = tourStay.stay?.filter(item => item.id !== id);
    if (updatedStay.length === 0) {
      // If empty, call onStaySelect with an empty object
      onStaySelect({});
    } else {
      // If there are remaining items, call onStaySelect with the formatted array
      const formattedStay = updatedStay.map(item => ({
        id: item.id,
        name: item.name,
        quantity: item.quantity,
      }));
      onStaySelect(formattedStay);
    /*setTourStay(prevState => ({
      ...prevState,
      stay: updatedStay || []
    }));*/
  }};


  useEffect(
    () => {
      //console.log("roomQuantities", roomQuantities);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [roomQuantities]
  );
  /*onStaySelect([
      {
        id: unit.id,
        name: unit.name,
        quantity: quantityRooms,
      },
    ]);
    */ const {
    data: accommodationUnits,
    isFetching,
    refetch,
    isError,
    //isSuccess,
  } = useQuery(
    ["stays", searchParams, currentPage],
    () => {
      return searchAccommodations({
        page: currentPage,
        ...Object.fromEntries(
          [...searchParams.entries()].filter(([key]) => key !== "rooms")
        ),
        // rooms: searchParams.get("rooms"), // re-enable for hotel room recommendations in tour stays
        location: tourStay.destination,
        start_date: tourStay.startDate,
        end_date: tourStay.endDate,
      });
    },
    {
      enabled: true,
      refetchOnWindowFocus: false,
      select: (payload) => payload.data,
      onSuccess: (data) => {
        if (currentPage === 1) setAccommodationsData(data.results);
        else setAccommodationsData([...accommodationsData, ...data.results]);
      },
    }
  );

  useEffect(() => {
    if (!accommodationsData) return;
    accommodationsData.forEach((accommodation) => {
      if (accommodation.type === "Hotel") {
        accommodation.units.forEach((unit) => {
          setRoomQuantities((prevRoomQuantities) => ({
            ...prevRoomQuantities,
            [unit.id]:
              prevRoomQuantities[unit.id] !== undefined
                ? prevRoomQuantities[unit.id]
                : 0,
            //setRoomQuantities({
            //  ...roomQuantities,
            //  [unit.id]: 0,
          }));
        });
      } else {
        // setRoomQuantities({
        //   ...roomQuantities,
        //   [accommodation.units[0].id]: 0,
        // });
      }
      //setRoomQuantities(
      //  Object.fromEntries(accommodationsData.units.map(({ id }) => [id, 0]))
      //);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accommodationsData]);

  useEffect(() => {
    if (isOpen) {
      setAccommodationsData([]);
      setCurrentPage(1);
      refetch();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);

  /* const fullStayName = (stay) => {
    return `${stay.name}`;

    //return `${
    //  stay.accommodationType === "hotel" ? stay.accommodationName + " - " : ""
    //}${stay.name}`;
  };
*/

  useEffect(() => {
    if (
      accommodationUnits?.pagination.nextPage &&
      accommodationUnits?.pagination.totalPages > currentPage
    )
      setHasNextPage(true);
    else setHasNextPage(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accommodationUnits]);

  const selectedRoomsToPills = () => {
    if (isFetching) return "";
    return Object.keys(roomQuantities)
      .filter((roomId) => roomQuantities[roomId] > 0)
      .map((roomId) => {
        /*accommodationsData.forEach((accommodation) => {
          accommodation.units.forEach((unit) => {
            if (unit.id == roomId) {
              const room = unit;
              const quantity = roomQuantities[roomId];
            }
          });
        });*/

        //const room = accommodationsData.units.find((room) => room.id == roomId);
        //const quantity = roomQuantities[roomId];

        const room = accommodationsData
          .flatMap((accommodation) => accommodation.units) // Flatten the array of units
          .find((unit) => Number(unit.id) === Number(roomId)); // Find the first unit with the matching roomId

        const quantity = room ? roomQuantities[roomId] : undefined;

        return (
          <Badge
            className="room-pill"
            variant={"outline"}
            mb={2}
            display="flex"
            size="md"
            alignItems="flex-start"
            flexWrap={"no-wrap"}
            borderRadius={7}
            direction={"column"}
          >
            <Text padding={1}>
              {room && quantity ? `${quantity}x ${room.name}` : ""}
            </Text>
            <CloseButton
              color={"gray.500"}
              size="sm"
              onClick={() =>
                setRoomQuantities({
                  ...roomQuantities,
                  [roomId]: 0,
                })
              }
            />
          </Badge>
        );
      });
  };

  return (
    <>
     <HStack>
      <Button leftIcon={<FontAwesomeIcon icon={faHotel} />}
          variant={"outline"} onClick={onOpen} colorScheme="teal"
              _hover={{
                bg: "teal.100",
                color: "black",
              }} >
        {tourStay?.stay?.length === 0 || !tourStay.stay[0]?.id || !tourStay.stay[0]?.name
          ? t("tours.stayMenu.chooseStayIn", { city: tourStay.destination })
          : t("tours.stayMenu.changeStay")}
      </Button>
     </HStack>
      {!tourStay?.stay[0]?.name ? (
        <UpsellBox  />
      ) : !tourStay.stay[0].id ? (
        <Alert status="info" backgroundColor={"lightblue"} >
          <AlertIcon />
          {t("tours.stayMenu.agentsChooseAccommodation")}
        </Alert>
      ) : (
        <HStack spacing={1} align="center" justify="center" direction="column" flexWrap={"wrap" }>
          {tourStay.stay.map((item, index) => (
              <HStack justify="space-between" rounded={"md"} border={"1px"} p={2} minW={"200px"}>
              <Badge size="md" variant="none" key={index}>

              {item.quantity}x {item.name}
            </Badge>
                <Box
                    display="inline-flex"
                    alignItems="center"
                    justifyContent="center"
                    width="25px"
                    height="25px"
                    borderRadius="full"
                    backgroundColor="red.500"
                    cursor="pointer"
                    onClick={() => removeItem(item.id)}
                >
                  <FontAwesomeIcon
                      icon={faTrashCan}
                      style={{ color: 'white' }}
                      size="md"
                  />
                </Box>
              </HStack>
          ))}
        </HStack>
      )}
      <Modal isOpen={isOpen} onClose={onClose} scrollBehavior={"inside"}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            {t("tours.stayMenu.accommodationsIn", {
              city: tourStay.destination,
              startDate: tourStay.startDate,
              endDate: tourStay.endDate,
            })}
          </ModalHeader>
          <ModalCloseButton
              _hover={{ bg: "red.500", color: "white" }}
              _active={{ bg: "red.700" }}
              color="red.500"
          />
          <ModalBody as={Flex} flexDirection={"column"} gap={7} pb={6}>
            {isFetching && currentPage === 1 ? null : isError ? (
              <p>{t("tours.stayMenu.errorLoadingStays")}</p>
            ) : accommodationUnits?.results?.length === 0 ? (
              <>
                <p>
                  {t("tours.stayMenu.noStaysAvailablePrefix")}{" "}
                  <strong>{tourStay.destination}</strong>{" "}
                  {t("tours.stayMenu.noStaysAvailableSuffix")}{" "}
                  <span style={{ fontWeight: "bold", color: "#319795" }}>
                    {t("tours.stayMenu.letUsChoose")}
                  </span>{" "}
                  {t("tours.stayMenu.noStaysAvailableEnd")}
                </p>
                <Button
                  onClick={() =>
                    onStaySelect([
                      {
                        id: null,
                        name: t("tours.stayMenu.staySelectedByAgents", {
                          city: tourStay.destination,
                        }),
                        quantity: 1,
                      },
                    ])
                  }
                  variant="outline"
                >
                  {t("tours.stayMenu.letUsChoose")}
                </Button>
              </>
            ) : (
              accommodationsData.map((accommodation, index) => (
                <>
                  {accommodation.type === "Hotel" ? (
                    <Accordion allowToggle>
                      <AccordionItem>
                        <h2>
                          <AccordionButton
                            _expanded={
                              {
                                /*bg: "silver", color: "white"*/
                              }
                            }
                          >
                            <Box as="span" flex="1" textAlign="left">
                              {accommodation.name}
                            </Box>
                            <AccordionIcon />
                          </AccordionButton>
                        </h2>
                        <AccordionPanel pb={4}>
                          {
                            <RoomPicker
                              isHotel={true}
                              previewOnly={false}
                              ref={roomPickerRef}
                              type={"Hotel"}
                              rooms={accommodation.units}
                              onRoomSelect={(id, quantity) => {
                                setRoomQuantities({
                                  ...roomQuantities,
                                  [id]: quantity,
                                });
                              }}
                            />
                            /*accommodation.units.map((unit, unitIndex) => (
                            <RoomCard
                              key={unit.id}
                              isForTour={true}
                              room={{
                                ...unit,
                                name: unit.name,
                                pricePerDay: unit.pricePerNight,
                                images: unit.images,
                              }}
                              type={accommodation.type}
                              onSelect={(quantityRooms) => {
                                //onRoomSelect(room.id, quantity);

                                if (accommodation.type === "Hotel") {
                                  setRoomQuantities({
                                    ...roomQuantities,
                                    //[roomId]: 0,
                                  });
                                }
                                onStaySelect([
                                  {
                                    id: unit.id,
                                    name: `${unit.name} (${accommodation.name})`,
                                    quantity: quantityRooms,
                                  },
                                ]);
                              }}
                            />
                          ))*/
                          }
                        </AccordionPanel>
                      </AccordionItem>
                    </Accordion>
                  ) : (
                    accommodation.units.map((unit, unitIndex) => (
                      <RoomCard
                        key={unit.id}
                        isForTour={true}
                        room={{
                          ...unit,
                          name: accommodation.name,
                          pricePerDay: unit.pricePerNight,
                          images: accommodation.images,
                        }}
                        type={accommodation.type}
                        onSelect={(quantityRooms) => {
                          onStaySelect([
                            {
                              id: unit.id,
                              name: unit.name,
                              quantity: quantityRooms,
                            },
                          ]);
                        }}
                      />
                    ))
                  )}
                </>
              ))
            )}
            {isFetching && currentPage > 1 && <AccommodationCardSkeleton />}
            {hasNextPage && (
              <Button
                height={"50px"}
                isLoading={isFetching}
                onClick={() => {
                  setCurrentPage(currentPage + 1);
                  setHasNextPage(true);
                }}
              >
                {t("tours.stayMenu.showMore")}
              </Button>
            )}
          </ModalBody>
          <ModalFooter as={Flex}>
            <HStack spacing={4} align="start" direction="column">
              <HStack
                spacing={2}
                flexWrap={"wrap"}
                overflowY={"auto"}
                maxHeight={"90px"}
              >
                {selectedRoomsToPills()}
              </HStack>

              {isFetching ? (
                <Spinner></Spinner>
              ) : (
                <VStack alignItems={"normal"}>
                  { accommodationUnits?.results?.length > 0 &&
                      <Button
                    mr={3}
                    colorScheme="teal"
                    onClick={() => {
                      const units = Object.keys(roomQuantities)
                        .filter((unitId) => roomQuantities[unitId] > 0) // Filter units with quantity > 0
                        .map((unitId) => {
                          const quantity = roomQuantities[unitId];
                          let matchedUnit = null;
                          for (const accommodation of accommodationsData) {
                            for (const unit of accommodation.units) {
                              if (Number(unit.id) === Number(unitId)) {
                                matchedUnit = {
                                  id: unitId,
                                  name: unit.name,
                                  quantity: quantity,
                                };
                                break;
                              }
                            }
                            if (matchedUnit) break;
                          }

                          return matchedUnit;
                        })
                        .filter((unit) => unit);

                      if (units.length === 0) {
                        alert(t("tours.stayMenu.selectAtLeastOneRoom"));
                        return;
                      }
                      onStaySelect(units);
                    }}
                  >
                    {t("tours.stayMenu.selectRooms")}
                  </Button>
                  }
                  <Button colorScheme="teal" size="sm" mr={3} onClick={onClose}>
                    {t("tours.stayMenu.close")}
                  </Button>
                </VStack>
              )}
            </HStack>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default ChooseStayMenu;
